import { FrontEndBrandIdentityGuideSchema } from "@redotech/redo-model/agents/aeo-agents/brand-identity-guide";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getAdminBrandIdentityGuide = unaryRpc({
  name: "getAdminBrandIdentityGuide",
  input: z.object({ teamId: zExt.objectId() }),
  output: FrontEndBrandIdentityGuideSchema.nullable(),
});
